// eslint-disable-next-line
export default {
    name: "Ingredients",
    status: {
        router: true,
        redux: true
    }
}
